import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { updateUserStatus } from '@/api/dataCenter/onlineStatus';
import store from '@/store';
export default {
  name: 'OnlineStatusCom',
  props: {
    onlineStatus: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      status: [{
        id: 0,
        label: '在线',
        tag: 'success'
      }, {
        id: 1,
        label: '离开',
        tag: 'info'
      }],
      actived: this.onlineStatus
    };
  },
  watch: {
    onlineStatus: function onlineStatus(newVal) {
      this.actived = newVal;
    }
  },
  methods: {
    handleStatus: function handleStatus(status) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.actived = status;
              _context.n = 1;
              return updateUserStatus({
                userId: store.state.user.user.id,
                status: status
              });
            case 1:
              res = _context.v;
              console.log(res);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};